import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { fetchData } from '../../../../helpers/methods';

import Button from '../../../../component-library/button';
import SpinnerContainer from '../../../../component-library/spinner-container';
import Pagination from '../../../../component-library/pagination';

const DesignSearch = ({
	type,
	handleApplyData,
	selectedRefData,
}) => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [pagination, setPagination] = useState({
		totalPages: 1,
		currentPage: 1,
	});
	const [query, setQuery] = useState({
		pageSize: 10,
		pageOffset: 0,
	});

	const getDesignData = () => {
		setLoading(true);

		const searchType = type === 'event' ? 'apps' : 'atlasid';

		fetchData({
			uri: `/api/web/ics/search/${searchType}?atlasid="${selectedRefData?.code}"&offset=${query.pageOffset}&pageSize=${query.pageSize}`,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const metaData = body.metadata;
					const newData = body.results;
					setPagination({
						...pagination,
						totalPages: Math.ceil(metaData.totalSize / query.pageSize),
					});
					setData(newData);
					setLoading(false);
				} else {
					setData([]);
					setLoading(false);
				}
			})
			.catch(() => {
				setData([]);
				setLoading(false);
			});
	};

	const handlePagination = currentPage => {
		const newOffset = (currentPage * query.pageSize) - query.pageSize;
		setPagination({
			...pagination,
			currentPage,
		});
		setQuery({
			...query,
			pageOffset: newOffset,
		});
	};

	const handleRowClick = item => {
		const newItem = {
			...selectedRefData,
			designName: item.name,
			designId: item.id,
		};
		handleApplyData(newItem);
	};

	const handleRegisterNewApplication = () => {
		const newItem = {
			...selectedRefData,
			designName: '',
			designId: '',
		};
		handleApplyData(newItem);
	};

	useEffect(() => {
		getDesignData();
	}, [query]);

	return (
		<>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				<>
					<table className="table is-bordered margin-bottom-32">
						<thead>
							<tr>
								<th>ID</th>
								<th>Name</th>
							</tr>
						</thead>
						<tbody>
							{data?.length ? (
								data.map((item, index) => (
									// eslint-disable-next-line react/no-array-index-key
									<tr className="is-clickable" key={index} role="presentation" onClick={() => handleRowClick(item)}>
										<td>{item.id}</td>
										<td>{item.name}</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2} className="grey-text text-center">No data available.</td>
								</tr>
							)}
						</tbody>
					</table>
					<div className="flex-row justify-space-between">
						<Button
							type="secondary"
							label="Register New Consumer Application"
							onClick={() => handleRegisterNewApplication()}
						/>
						<Pagination
							totalPages={pagination.totalPages}
							currentPage={pagination.currentPage}
							action={currentPage => handlePagination(currentPage)}
						/>
					</div>
				</>
			)}
		</>
	);
};

export default DesignSearch;

DesignSearch.propTypes = {
	type: PropTypes.string.isRequired,
	handleApplyData: PropTypes.func.isRequired,
	selectedRefData: PropTypes.shape({
		code: PropTypes.string.isRequired,
	}).isRequired,
};
